import {useMutation, useQueryClient} from "@tanstack/react-query";
import {ProjectResType} from "../interface";
import {updateProjectApi} from "../../../../api/correspondent/projectApi";
import {useModal} from "../../../../hooks";

/**
 * 프로젝트 수정
 * @param props
 * @returns
 */
export const useUpdateProject = (afterCallback: any) => {
    const qc = useQueryClient()
    const {handleModal} = useModal()

    const {mutate} = useMutation({
        mutationFn: (data: ProjectResType) => updateProjectApi(data),
        onSuccess: (res) => {
            if (res.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readProjectDetail"]})
                        afterCallback()
                    }
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.msg,
                    type: "alert",
                })
            }
        },
        onError: (err) => {
            console.log(err);
        },
    });

    return {mutate};
};
